module.exports = __webpack_public_path__ + "static/media/logo-sem-fundo.e0526f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-sem-fundo.png
// module id = 338
// module chunks = 0